import { Injectable, Inject } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { LiftParameterSettingsDetail } from '../models/list-parameter-settings-detail';
import { LiftParameterSettingsList } from '../models/lift-parameter-settings-list.model';
import { LiftParameterSettingsUpdate } from '../models/lift-parameter-settings-update.model';
import { LiftParameterSettingsCreate } from '../models/list-parameter-settings-create.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LiftBoardParameterCreate } from '../models/lift-board-parameter-create';
import { LiftBoardParameterUpdate } from '../models/lift-board-parameter-update.model';
import { LiftBoardParameterDetail } from '../models/lift-board-parameter-detail.model';

@Injectable({
  providedIn: 'root'
})
export class LiftBoardParameterService extends EntityService<LiftBoardParameterDetail, LiftParameterSettingsList, LiftBoardParameterUpdate, LiftBoardParameterCreate> {
  constructor(
    httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(httpClient, baseUrl + 'api/liftBoardParameter');
  }

  delete(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.delete(url);
  }
}
